import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import auth0 from './core/config/auth0';
import { cidInterceptorFn } from './core/interceptors/cid.interceptor';
import { ApiInterceptor } from './core/interceptors/api.interceptor';
import { matConfig } from '@shared/matConfig';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([
      authHttpInterceptorFn,
      cidInterceptorFn,
      ApiInterceptor,
    ])),
    provideRouter(routes),
    provideAuth0(auth0),
    { provide: LOCALE_ID, useValue: 'en-gb' },
    ...matConfig,
  ]
};
